import { useSubscription } from '@apollo/client'
import { createContext, useState } from 'react'

import { GET_SAMPLE_DATA } from 'src/schema/subscriptions'
import logger from 'src/utils/logger'

const DummyDataContext = createContext()

export default DummyDataContext

export const DummyDataContextProvider = ({ children }) => {
    const [hasDummyData, setHasDummyData] = useState(false)
    const { error } = useSubscription(GET_SAMPLE_DATA, {
        onData: ({ data: subscriptionData }) => {
            const result = subscriptionData.data.organizations[0]
            setHasDummyData(result.hasSampleData)
        },
    })

    if (error) {
        logger.error(`failed to get sample data flag for org`)
        logger.error(error.message)
        logger.error(error.extraInfo)
        logger.error(error)
        return (
            <DummyDataContext.Provider value={false}>
                {children}
            </DummyDataContext.Provider>
        )
    }

    return (
        <DummyDataContext.Provider value={hasDummyData}>
            {children}
        </DummyDataContext.Provider>
    )
}
